import {useState} from "react";
import {observer} from "mobx-react";
import {CloseSquare, Trash} from "iconsax-react";
import {Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Typography, Button} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import styles from '../my-data.module.scss';

const DeleteCategoryModal = observer(({category, uiStore, feedback,onTabClick,onDeleteCategory, updateData}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const confirm = async (e) => {
        setLoading(true);
        await uiStore.deleteCategory(category._id, category.name);
        const data = await uiStore.fetchCategoryInfo(category.name, true);
        updateData(data);
        setLoading(false);
        if (feedback)
            feedback();
        setShow(false);
        onTabClick(e,0);
        onDeleteCategory('Images');
    }

    return (
        <Box sx={{textAlign: 'center'}}>

            <Button
                variant="contained"
                onClick={() => setShow(true)}
                color="error"
                className={`${styles.mydataDeleteBtn}`}
            >
                <Trash
                    size="24"
                    variant="Bulk"
                />
                <Box className={styles.hideText}>Delete {category?.name}</Box>
            </Button>

            <Dialog open={show} onClose={() => setShow(false)}
                    PaperProps={{sx: {padding: '20px'}, variant: 'round'}}
            >
                <DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{textAlign: 'center'}}>
                    <Box className={styles.deleteIconContainer}>
                        <Trash
                            size="30"
                            variant="Bulk"
                        />
                    </Box>
                    <Typography fontWeight={600}>Delete {category?.name} category</Typography>
                    <Typography color='#888888'>Are you sure you want to
                        delete {category?.name} category?</Typography>

                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={() => setShow(false)} variant="contained"
                                   color="lightblue">
                        Cancel
                    </LoadingButton>
                    <LoadingButton loading={!!loading} onClick={confirm} variant="contained" color="error">
                        Delete
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box>
    );
});

export default DeleteCategoryModal;
